import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import { RFP_NEGOTIATE_STATUSES } from '@/utils/constants/rfp/rfpNegotiate/status';
const statuses = {
    received: 'info',
    sent: 'inactive',
};
/**
 * コンサルタント：案件条件相談の返信状況を示すステータスタグを表示するコンポーネント
 * TODO: modules/Chat 配下に移動して共通化
 * @constructor
 */
export const RfpProfessionalNegotiateStatusTag = (props) => {
    const { className = '', status } = props;
    const value = useMemo(() => RFP_NEGOTIATE_STATUSES.find((v) => v.value === status), [status]);
    return (_jsx(SmallTag, Object.assign({ className: className, color: statuses[status] }, { children: value === null || value === void 0 ? void 0 : value.professionalLabel })));
};
